import { CreateMyTextPresetArgs } from '@sparemin/api-sdk';
import React from 'react';
import ResizeDetector from 'react-resize-detector';

import TextPresetSelector from 'components/TextPresetSelector';
import { ImmutableTextPreset } from 'redux/modules/text-presets';

import { LocalPresetsList } from '../../extensions/LocalPresets';
import { block } from '../../utils';

interface TextOverlayPresetsProps {
  currentPresetConfig?: CreateMyTextPresetArgs;
  selectedPreset?: ImmutableTextPreset;
  onPickPreset: (presetStyles: ImmutableTextPreset) => void;
}

const TextOverlayPresets: React.FunctionComponent<TextOverlayPresetsProps> = props => {
  const { currentPresetConfig, selectedPreset, onPickPreset } = props;

  const [wrapperWidth, setWrapperWidth] = React.useState(0);

  const handleResize = React.useCallback((width: number): void => {
    setWrapperWidth(width);
  }, []);

  return (
    <ResizeDetector handleWidth onResize={handleResize}>
      <div className={block('presets-toolbar-container')}>
        <TextPresetSelector
          // Fixes an issue that was producing the fades not to appear when the modal
          // was just opened
          key={String(wrapperWidth)}
          localPresets={<LocalPresetsList />}
          mode="horizontal"
          onPickPreset={onPickPreset}
          selectedPreset={selectedPreset}
          currentPresetConfig={currentPresetConfig}
        />
      </div>
    </ResizeDetector>
  );
};

export default TextOverlayPresets;
